/**
 * Authentication error types and interfaces
 * Provides structured error handling for authentication operations
 */

export enum AuthErrorType {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  MAX_DEVICES = 'MAX_DEVICES',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN = 'UNKNOWN'
}

export interface AuthError {
  type: AuthErrorType;
  message: string;
  originalError?: any;
}

/**
 * Create an AuthError from an error type and message
 */
export const createAuthError = (
  type: AuthErrorType,
  message: string,
  originalError?: any
): AuthError => ({
  type,
  message,
  originalError
});

/**
 * Create an AuthError from a network error
 */
export const createNetworkError = (originalError?: any): AuthError => ({
  type: AuthErrorType.NETWORK_ERROR,
  message: 'Network error. Please check your connection.',
  originalError
});

/**
 * Create an AuthError from a token expiration
 */
export const createTokenExpiredError = (): AuthError => ({
  type: AuthErrorType.TOKEN_EXPIRED,
  message: 'Your session has expired. Please log in again.'
});

/**
 * Create an AuthError from invalid credentials
 */
export const createInvalidCredentialsError = (): AuthError => ({
  type: AuthErrorType.INVALID_CREDENTIALS,
  message: 'البريد الإلكتروني أو الباسورد غير صحيح'
});

/**
 * Create an AuthError from max devices error
 */
export const createMaxDevicesError = (): AuthError => ({
  type: AuthErrorType.MAX_DEVICES,
  message: "You can't log in from more than two devices."
});
